export function getCustomerAdvancedDigest(filters: Record<string, string>) {
  let othersFilters = {};
  let metafieldsFilters = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (key.startsWith('mf-') && value !== '') {
      metafieldsFilters = {
        ...metafieldsFilters,
        [key.split('mf-')[1]]: `${value}`,
      };
      return;
    }
    if (key === 'page' || key === 'perPage' || key === 'hasPriceTable') {
      othersFilters = { ...othersFilters, [key]: value };
    }
  });

  const metafieldsFiltersArray = Object.entries(metafieldsFilters);

  return {
    ...othersFilters,
    metafields: metafieldsFiltersArray.length
      ? metafieldsFiltersArray
      : undefined,
  };
}
